if (WebPageObj.customerPrivacyOptInOptOut) {
    $(() => {
        CustomerPrivacyOptInOptOutApp.init();
    });
}

/**
 * Object to handle the app code.
 *
 * @type Object
 */
const CustomerPrivacyOptInOptOutApp = function() {
    const saveOptInOptOutBtn = $("#saveOptInOptOut");
    const feedbackPanelContainer = $(".hiddenFeedbackPanel");
    const generalFailureError = "An unexpected error has occurred. Please try again or submit an inquiry to privacy@avasflowers.com, if the problem persists.";

    return {
        /**
         * Initialize the application
         */
        init: function() {
            // When the save button is clicked
            saveOptInOptOutBtn.on("click", (e) => {
                e.preventDefault();
                this.updateOptInOptOut();
            });
        },

        /**
         * Method to make the AJAX call to update the opt in - opt out
         */
        updateOptInOptOut: function() {
            const waitMsg = "Saving ...";
            const originalBtnMsg = saveOptInOptOutBtn.val();

            // Do not proceed if an existing request is being handled
            if (originalBtnMsg === waitMsg) return;

            // Check if an option is selected
            // in theory, this should not never happen because a default option should be seleced by default
            const selectedOption = $("input[name='optInOptOutRadio']:checked");
            if (selectedOption.length === 0) {
                this.displayOOFeedbackPanel('error', "Please select an option: Yes or No.");
                return;
            }

            saveOptInOptOutBtn.val(waitMsg);
            feedbackPanelContainer.hide();

            $.ajax({
                url: "/customer_privacy/update_optin_optout",
                method: "POST",
                data: { status: selectedOption.val() },
                dataType: "json",
                success: (data) => {
                    const panelType = data.status ? 'success' : 'error';
                    this.displayOOFeedbackPanel(panelType, data.message);
                    // add back the original button text
                    saveOptInOptOutBtn.val(originalBtnMsg);
                },
                error: () => {
                    this.displayOOFeedbackPanel('error', generalFailureError);
                    // add back the original button text
                    saveOptInOptOutBtn.val(originalBtnMsg);
                }
            });
        },

        /**
         * Display the feedback panel
         * @param {string} type - The type of feedback: error, success, info
         * @param {string} message - The message to display
         */
        displayOOFeedbackPanel: function(type, message) {
            displayFeedbackPanel(null, feedbackPanelContainer, type, message);
        }
    };
}();